"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createProvideCss = void 0;
const provide_component_1 = require("@wix/services-manager-react/core-services/provide-component");
const react_1 = require("react");
const createProvideCss = (getService) => {
    const provideComponentService = getService(provide_component_1.ProvideComponentServiceDefinition);
    const addGlobalStyle = (newCss) => {
        if (!newCss)
            return;
        const CSSProvider = () => (0, react_1.createElement)('style', null, newCss.trim());
        provideComponentService.addBottomComponent(CSSProvider);
    };
    return {
        addGlobalStyle,
    };
};
exports.createProvideCss = createProvideCss;
//# sourceMappingURL=provideCss.js.map